import React, { PureComponent } from 'react';
import {
  Box,
  Paper,
  Typography,
  FormLabel,
  Tabs,
  Tab,
  Button,
  LinearProgress,
  FormGroup,
  FormControlLabel,
  Checkbox,
  TextField,
} from '@material-ui/core';
import { AutoSuggest, Chip, Slider } from 'common';
import { skills, skillsRecommendation } from 'controllers/taxonomies';
import { uuid } from 'utils';
import {
  removeCollege,
  removeDomain,
  addDomain,
  addCollege,
} from 'controllers/job';

class Qualification extends PureComponent {
  constructor() {
    super();
    this.state = {
      recommendedSkills: {},
      isShowSkill: false,
      college: '',
      industrie: '',
    };
  }

  fetchSkills = async (value) => {
    const skillArray = await skills(value);
    return await skillArray.response.map(({ skill }) => skill);
  };

  fetchSkillRecommendations = async (skillArray) => {
    const skills = await skillsRecommendation(skillArray);
    this.setState({
      recommendedSkills: skills.response || {},
    });
  };

  onSelectSkill = (e, value) => {
    const { onSelectSkill, skills } = this.props;
    if (!value) {
      onSelectSkill(e);
      this.fetchSkillRecommendations([...skills, e]);
    } else {
      onSelectSkill(value.suggestion);
      this.fetchSkillRecommendations([...skills, value.suggestion]);
    }
  };

  onDeleteSkill = (value) => {
    const { onDeleteSkill, skills } = this.props;
    onDeleteSkill(value);
    this.fetchSkillRecommendations(skills.filter((skill) => skill !== value));
  };

  clickCheckBox = (label, selected) => {
    //console.log(label, selected);
  };

  onClickHandel = () => {
    this.setState({
      isShowSkill: !this.state.isShowSkill,
    });
  };

  onChangeIndustrie = (e) => {
    this.setState({
      industrie: e.target.value,
    });
  };

  onKeyDownCollege = (e) => {
    if (e.key !== 'Enter') return;
    addCollege(e.target.value);
    this.setState({
      college: '',
    });
  };

  onChangeCollege = (e) => {
    this.setState({
      college: e.target.value,
    });
  };

  onDeleteCollege = (college) => (e) => {
    removeCollege(college);
  };

  onKeyDownIndustrie = (e) => {
    if (e.key !== 'Enter') return;
    addDomain(e.target.value);
    this.setState({
      industrie: '',
    });
  };

  onDeleteDomain = (domain) => {
    removeDomain(domain);
  };

  render() {
    const {
      educationRequired,
      onChangeExperience,
      skills,
      skillSearch,
      onChange,
      minExperience,
      maxExperience,
      errorFlag,
      onChangeHandlerEducation,
      domains,
      lookForSchools,
    } = this.props;

    const { recommendedSkills, college, industrie } = this.state;

    const errorClass =
      errorFlag && !Boolean(educationRequired.length) ? 'error' : '';

    const experienceErrorFlag =
      errorFlag && (minExperience === null || maxExperience === null);

    return (
      <>
        <Paper
          square
          elevation={0}
          className="qualification"
          id="qualification"
        >
          {/* <Box pb="18px">
          <Typography variant="body1" className="font-weight-500">
            Qualification
          </Typography>
        </Box> */}
          <Box mt="10px" className={errorClass}>
            <FormLabel component="legend" className="label">
              Education ( *required )
            </FormLabel>
            <FormGroup row>
              <Box p="10px 0">
                {/* <ChipCheckbox
                label="Bachelor's"
                onClick={this.clickCheckBox}
              ></ChipCheckbox>
              <ChipCheckbox
                label="Master's"
                onClick={this.clickCheckBox}
              ></ChipCheckbox>
              <ChipCheckbox
                label="Doctorate"
                onClick={this.clickCheckBox}
              ></ChipCheckbox>
              <ChipCheckbox
                label="Diploma"
                onClick={this.clickCheckBox}
              ></ChipCheckbox> */}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Boolean(
                        educationRequired.find(
                          (education) => education === 'Diploma'
                        )
                      )}
                      onChange={onChangeHandlerEducation}
                      name="educationRequired"
                      value="Diploma"
                      color="primary"
                    />
                  }
                  label="High School Diploma"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Boolean(
                        educationRequired.find(
                          (education) => education === "Bachelor's"
                        )
                      )}
                      onChange={onChangeHandlerEducation}
                      name="educationRequired"
                      value="Bachelor's"
                      color="primary"
                    />
                  }
                  label="Bachelor's"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Boolean(
                        educationRequired.find(
                          (education) => education === "Master's"
                        )
                      )}
                      onChange={onChangeHandlerEducation}
                      name="educationRequired"
                      value="Master's"
                      color="primary"
                    />
                  }
                  label="Master's"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Boolean(
                        educationRequired.find(
                          (education) => education === 'Doctorate'
                        )
                      )}
                      onChange={onChangeHandlerEducation}
                      name="educationRequired"
                      value="Doctorate"
                      color="primary"
                    />
                  }
                  label="Doctorate"
                />
              </Box>
            </FormGroup>
          </Box>
        </Paper>
        <Paper square elevation={0} className="qualification">
          <Box className={''}>
            <FormLabel component="legend">
              Add colleges and schools you want to look from{' '}
            </FormLabel>
            <TextField
              // helperText={minSalaryErrorMsg}
              name="college"
              label="Add Colleges and schools"
              placeholder="Enter the name of the college , Schools"
              margin="normal"
              variant="outlined"
              value={college}
              onChange={this.onChangeCollege}
              onKeyDown={this.onKeyDownCollege}
              fullWidth
            />
            {lookForSchools.map((college) => {
              return (
                <Chip
                  key={uuid()}
                  label={college}
                  onDeleteChip={this.onDeleteCollege(college)}
                />
              );
            })}
          </Box>
        </Paper>
        <Paper square elevation={0} className="qualification">
          <Box className={experienceErrorFlag ? 'error' : ''}>
            <FormLabel component="legend" className="label">
              Work Experience ( * in Years )
            </FormLabel>
            <Box p="20px 10px 0 10px" width="70%">
              <Slider
                max={50}
                value={[minExperience, maxExperience]}
                onChange={onChangeExperience}
              />
              <p className="error-message">
                Minimum or maximum work experience should not be null
              </p>
            </Box>
          </Box>
        </Paper>
        <Paper
          square
          elevation={0}
          className="qualification"
          style={{ position: 'relative' }}
        >
          {Object.keys(recommendedSkills).length ? (
            <Paper
              square
              elevation={0}
              className="qualification"
              style={{
                position: 'absolute',
                left: 'calc(100% + 24px)',
                top: '-15px',
                width: '40.5%',
              }}
            >
              <Typography>Skills</Typography>
              <Tabs
                value={0}
                indicatorColor="primary"
                textColor="primary"
                // onChange={handleChange}
                aria-label="disabled tabs example"
              >
                <Tab
                  style={{ textTransform: 'unset', fontFamily: 'roboto' }}
                  label="Market insight"
                />
              </Tabs>
              <Box pt="10px">
                <Typography variant="body2">
                  Based on the 300,000 company preferences below
                </Typography>
              </Box>
              <Box pt="15px">
                {Object.keys(recommendedSkills)
                  .map((skill) => {
                    return (
                      <Box pb="10px" key={skill}>
                        <Typography variant="body2">{skill}</Typography>
                        <LinearProgress
                          variant="determinate"
                          value={recommendedSkills[skill] * 10}
                        />
                      </Box>
                    );
                  })
                  .filter((skill, index) => {
                    return index < 4;
                  })}
                {this.state.isShowSkill
                  ? Object.keys(recommendedSkills)
                      .map((skill) => {
                        return (
                          <Box pb="10px" key={skill}>
                            <Typography variant="body2">{skill}</Typography>
                            <LinearProgress
                              variant="determinate"
                              value={recommendedSkills[skill] * 10}
                            />
                          </Box>
                        );
                      })
                      .filter((skill, index) => {
                        return index >= 4;
                      })
                  : null}
              </Box>
              <Box pt="10px">
                <Button
                  style={{ fontFamily: 'roboto' }}
                  onClick={this.onClickHandel}
                >
                  {this.state.isShowSkill ? (
                    <span>- show less </span>
                  ) : (
                    <span>
                      +{' '}
                      {
                        Object.keys(recommendedSkills).filter(
                          (skill, index) => {
                            return index >= 4;
                          }
                        ).length
                      }{' '}
                      more
                    </span>
                  )}
                </Button>
              </Box>
            </Paper>
          ) : null}

          <FormLabel component="legend" className="label">
            Skills ( *required )
          </FormLabel>
          <Box>
            <AutoSuggest
              placeholder={'Type the relevant skills to find the match'}
              value={skillSearch}
              name="skillSearch"
              onChange={onChange}
              fetchSuggestions={this.fetchSkills}
              onSelect={this.onSelectSkill}
              enableSelectionOnEnter
              errorFlag={errorFlag && !Boolean(skills.length)}
              errorMessage="This field is required."
            />
          </Box>
          {skills.map((skill) => {
            return (
              <Chip
                key={uuid()}
                label={skill}
                onDeleteChip={this.onDeleteSkill}
              />
            );
          })}
          {Boolean(Object.keys(recommendedSkills).length) && (
            <Box pb="5px" pt="20px">
              <FormLabel component="legend">Recommended Skills</FormLabel>
              <Box pt="20px">
                {Object.keys(recommendedSkills).map((skill) => {
                  return (
                    <Chip
                      key={uuid()}
                      label={skill}
                      onClick={this.onSelectSkill}
                    />
                  );
                })}
              </Box>
            </Box>
          )}
        </Paper>
        <Paper square elevation={0} className="qualification">
          <Box>
            <TextField
              // helperText={minSalaryErrorMsg}
              name="college"
              label="Industries & Domain"
              placeholder="Enter Domains"
              margin="normal"
              variant="outlined"
              value={industrie}
              onChange={this.onChangeIndustrie}
              onKeyDown={this.onKeyDownIndustrie}
              fullWidth
            />
            {domains.map((industrie) => {
              return (
                <Chip
                  key={uuid()}
                  label={industrie}
                  onDeleteChip={this.onDeleteDomain}
                />
              );
            })}
          </Box>
        </Paper>
      </>
    );
  }
}

export default Qualification;
